import styled, { useTheme } from "styled-components";
import { CopyToClipboardButton } from "common/CopyToClipboard/CopyToClipboard";
import React, { CSSProperties } from "react";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import Flex from "common/Boxes/Flex";
import CopyOutlined from "@ant-design/icons/CopyOutlined";
import { copyToClipboardInputStyles } from "@shared/common/CopyToClipboard/styles";

interface CopyToClipboardInputProps {
  text?: string;
  notificationPrefix?: string;
  style?: CSSProperties;
  onCopyClick?: () => void;
  dataTestId?: string;
}

const CopyToClipboardInput = ({
  text,
  notificationPrefix,
  style,
  onCopyClick,
  dataTestId,
}: CopyToClipboardInputProps) => {
  const appTheme = useTheme();
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  return (
    <Flex style={style}>
      <CopyInputWrapper>{text}</CopyInputWrapper>
      <StyledCopyToClipboardButton
        children={
          <>
            <CopyOutlined style={{ marginRight: isMobile ? 0 : 4 }} />
            {!isMobile && "Copy"}
          </>
        }
        name={notificationPrefix}
        text={text || ""}
        style={{
          background: appTheme.colors.primaryBlue,
          color: appTheme.colors.buttonText,
        }}
        $isMobile={isMobile}
        onCopyClick={onCopyClick}
        data-testid={dataTestId}
      />
    </Flex>
  );
};

export default CopyToClipboardInput;

const CopyInputWrapper = styled.div`
  ${copyToClipboardInputStyles.inputWrapper};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: ${(p) => p.theme.borders.lightest};
`;
const StyledCopyToClipboardButton = styled(CopyToClipboardButton)<{
  $isMobile: boolean;
}>`
  &.ant-btn.ant-btn-round {
    border-radius: 0 8px 8px 0;!important;
  }
  ${copyToClipboardInputStyles.button};
`;
